import { useCallback, useRef } from "react";
import type { GridEventListener } from "@mui/x-data-grid";
import { useNavigate } from "infrastructure/router";

export const useApplicationTableResourceEvents = () => {
    const navigate = useNavigate();
    const navigateRef = useRef(navigate);
    navigateRef.current = navigate;

    const onRowClick: GridEventListener<"rowClick"> = useCallback(({ id }) => navigateRef.current(`${id}`), []);

    return {
        onRowClick
    };
};

export default useApplicationTableResourceEvents;
